import React from 'react';
import styled from 'styled-components';

import { Text } from '../atom/Text';
import { Flex } from '../atom/Layout';
import PageTemplate from './PageTemplate';
import { ClipLoader } from 'react-spinners';

import useEventVoucher from '../../../Hooks/useEventVoucher';

const EventDetailTemplate = ({
  title,
  period: { startDate, endDate },
  children,
}) => {
  return (
    <PageTemplate title={'이벤트 상세'}>
      <Flex column alignItems="flex-start">
        <Text size={18} weight="bold">
          {title}
        </Text>
        <Text size={14} style={{ margin: '0.625rem 0 1.25rem' }}>
          기간 | {`${startDate.split('T')[0]} ~ ${endDate.split('T')[0]}`}
        </Text>
      </Flex>
      {children}
    </PageTemplate>
  );
};

export default React.memo(EventDetailTemplate);

export const EventDetailTemplateOnlyImages = ({
  event: { title, period, images },
}) => {
  return (
    <EventDetailTemplate title={title} period={period}>
      {images.map((image, imageidx) => {
        const { src, alt } = image;
        return <img src={src} alt={alt} key={imageidx} width="100%" />;
      })}
    </EventDetailTemplate>
  );
};

export const EventDetailTemplateWithButtons = ({
  event: {
    title,
    period,
    images: { src, alt },
    buttons,
  },
}) => {
  const { onClickEventButton, isLoading } = useEventVoucher();

  return (
    <EventDetailTemplate title={title} period={period}>
      <ButtonRelativeDiv>
        {buttons.map((button, buttonIdx) => {
          const { position, event, image } = button;
          return (
            <ButtonWrapper top={position.top} key={buttonIdx}>
              {event.type === 'voucher' && isLoading ? (
                <Flex
                  width="11.5rem"
                  height="2.188rem"
                  style={{ background: '#2a2a2a', borderRadius: '1.5rem' }}
                >
                  <ClipLoader color={'#ffffff'} size={24} />
                </Flex>
              ) : (
                <img
                  src={image.src}
                  alt={image.alt}
                  onClick={() => onClickEventButton(event)}
                />
              )}
            </ButtonWrapper>
          );
        })}
        <img src={src} alt={alt} width="100%" />
      </ButtonRelativeDiv>
    </EventDetailTemplate>
  );
};

const ButtonWrapper = styled.div`
  position: absolute;
  top: ${(props) => props.top};
  width: 100%;
  text-align: -webkit-center;

  img {
    height: 2.188rem;
    cursor: pointer;
  }
`;

const ButtonRelativeDiv = styled.div`
  position: relative;
`;
